<template>
  <v-btn
    tile
    large
    color="primary"
    class="non-text-transformation link"
    :disabled="disabled || hidden"
    :loading="loading"
    @click="handleClick"
    data-cy="button-continue"
  >
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: 'CtaButton',
  props: {
    type: {
      type: String,
      default: 'continue',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labelMap: {
        continue: this.$t('STEPPER_BUTTON_AFTER'),
        end: this.$t('STEPPER_BUTTON_END'),
        sign: this.$t('STEPPER_BUTTON_SIGN'),
      },
    }
  },
  computed: {
    label() {
      return this.labelMap[this.type] ?? ''
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>
